<template>
    <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
        <div class="mb-10 font-weight-bold text-dark">
            {{ __('actions.assign_thing', {thing: __('agency.agency')}) }}
        </div>
        <div class="form-group fv-plugins-icon-container">
            <label>{{ __('agency.agency') }}</label>
            <SelectAgency :agencies="agencies"
                          v-on:selected="agency => $emit('input', agency)"
            />
            <span class="form-text text-muted">Bitte geben Sie die E-Mail Adresse der einzuladenden Person ein</span>
            <div class="fv-plugins-message-container"/>
        </div>
    </div>
</template>

<script>
import SelectAgency from "@components/Agency/SelectAgency.vue";

export default {
    components: {SelectAgency},

    props: {
        agencies: Array,
        value: Object
    }
}
</script>
